import * as types from './mutations-types'

export default {}